import type { SVGProps } from "react";
export const FeatureSearch = (props: SVGProps<SVGSVGElement>) => (
	<svg
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		aria-hidden={true}
		{...props}
	>
		<path
			d="M18 12.8845L19.5 14.3845V21.5H2.5V4.5H9.7405C9.6455 4.74233 9.57592 4.98942 9.53175 5.24125C9.48758 5.49325 9.452 5.74617 9.425 6H4V20H18V12.8845ZM18.877 8.823L22.1345 12.0808L21.0807 13.1345L17.823 9.877C17.4987 10.109 17.1381 10.2901 16.7413 10.4202C16.3446 10.5503 15.9308 10.6152 15.5 10.6152C14.3525 10.6152 13.3798 10.2162 12.5817 9.41825C11.7837 8.62025 11.3848 7.6475 11.3848 6.5C11.3848 5.3525 11.7837 4.37975 12.5817 3.58175C13.3798 2.78375 14.3525 2.38475 15.5 2.38475C16.6475 2.38475 17.6202 2.78375 18.4183 3.58175C19.2162 4.37975 19.6152 5.3525 19.6152 6.5C19.6152 6.95 19.547 7.36858 19.4105 7.75575C19.274 8.14292 19.0962 8.49867 18.877 8.823ZM17.3568 8.35675C17.8626 7.85092 18.1155 7.232 18.1155 6.5C18.1155 5.768 17.8626 5.14908 17.3568 4.64325C16.8509 4.13742 16.232 3.8845 15.5 3.8845C14.768 3.8845 14.1491 4.13742 13.6432 4.64325C13.1374 5.14908 12.8845 5.768 12.8845 6.5C12.8845 7.232 13.1374 7.85092 13.6432 8.35675C14.1491 8.86258 14.768 9.1155 15.5 9.1155C16.232 9.1155 16.8509 8.86258 17.3568 8.35675ZM4 20V6V12.6152V12.325V20Z"
			fill="currentColor"
		/>
	</svg>
);
